import React, { useRef, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { useTranslation } from 'react-i18next';
import { LeafletPopupProps } from '../../types';
import Button from '../../../Button';

import './style.scss';

const popupWrapperId = 'leaflet-marker-container';

export const LeafletPopup: React.FC<LeafletPopupProps> = (props) => {
  const { t } = useTranslation();

  const {
    title,
    projectStatus,
    projectType,
    url,
  } = props;

  return (
    <div id={popupWrapperId}>
      <div className="LeafletPopup">
        <h4 className="m-0 mb-1">{title}</h4>
        <p className="m-0 mb-1">{projectStatus[0]}</p>
        <p className="m-0 mb-3">{projectType.map((type, index) => `${type}${index >= projectType.length - 1 ? '' : ', '}`)}</p>
        <Button href={url}>{t('pages.node_project.more_info')}</Button>
      </div>
    </div>
  );
};

export const LeafletPopupContent: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const popup = document.getElementById(popupWrapperId)?.innerHTML || '';
    if (ref.current) {
      ref.current.innerHTML = popup;
    }
  }, []);

  return (
    <div ref={ref} />
  );
};

export const popupContentConstructor = () => {
  const div = document.createElement('div');
  const root = createRoot(div);

  root.render(
    <LeafletPopupContent />,
  );
  return div;
};
